import { useAuth } from "@/context/AuthContext";
import { ShieldAlert, ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

/**
 * Blocks children unless the current user holds `role`.
 * Renders a full-screen "clearance required" screen otherwise.
 */
export default function RoleGate({ role, children }) {
    const { user } = useAuth();
    const nav = useNavigate();
    const roles = user?.roles || [];
    if (roles.includes(role)) return children;

    return (
        <div className="h-screen bg-virtus-bg text-white flex items-center justify-center">
            <div className="max-w-md text-center px-8">
                <ShieldAlert size={64} className="mx-auto text-virtus-stuck mb-6" />
                <div className="font-mono text-[10px] tracking-[0.32em] uppercase text-virtus-stuck mb-3">
                    ACCESS DENIED // CLEARANCE INSUFFICIENT
                </div>
                <h1 className="font-heading text-4xl font-black uppercase tracking-tighter mb-4">
                    Restricted Area
                </h1>
                <p className="text-virtus-dim text-sm mb-8">
                    This focus area requires <span className="text-virtus-orange font-mono">'{role}'</span> clearance. Contact an admin (currently{" "}
                    <span className="text-virtus-orange font-mono">dan@virtusmaritime.com</span>) to request access.
                </p>
                <button
                    onClick={() => nav("/hub")}
                    className="inline-flex items-center gap-2 px-5 py-3 font-mono text-[10px] tracking-[0.28em] uppercase bg-virtus-orange text-black hover:bg-white glow-orange"
                    data-testid="role-gate-back-btn"
                >
                    <ArrowLeft size={12} /> RETURN TO HUB
                </button>
            </div>
        </div>
    );
}
